export default __webpack_public_path__ + "static/confirmation-ppq-modal-images-fd138bf61c3606298c692d803cc73185.png";